import React from "react";
import { useLang } from "./Basei18n";
import { IntlProvider } from "react-intl";
import "@formatjs/intl-relativetimeformat/polyfill";
import "@formatjs/intl-relativetimeformat/locale-data/en";
import "@formatjs/intl-relativetimeformat/locale-data/ar";
import "@formatjs/intl-relativetimeformat/locale-data/fa";

import arMessages from "./messages/ar";

// Loaded  SubSystems English Messages and generate Single Object as "enMessages"
import CommonEn from "./messages/General/en";
import BaseInfoEn from "./messages/BaseInfo/en";
import AttendanceEn from "./messages/Attendence/en";
import SportEn from "./messages/Sport/en";
import DormEn from "./messages/Dorm/en";

// Loaded  SubSystems Farsi Messages and generate Single Object as "faMessages"
import CommonFa from "./messages/General/fa";
import BaseInfoFa from "./messages/BaseInfo/fa";
import AttendanceFa from "./messages/Attendence/fa";
import SportFa from "./messages/Sport/fa";
import DormFa from "./messages/Dorm/fa";

const enMessages = { ...CommonEn, ...BaseInfoEn, ...AttendanceEn, ...SportEn, ...DormEn };
const faMessages = { ...CommonFa, ...BaseInfoFa, ...AttendanceFa, ...SportFa, ...DormFa };

const allMessages = {
  ar: arMessages,
  en: enMessages,
  fa: faMessages,
};

export function I18nProvider({ children }) {
  const locale = useLang();
  const messages = allMessages[locale];

  return (
    <IntlProvider locale={locale} messages={messages}>
      {children}
    </IntlProvider>
  );
}
